/**
 * Typed endpoint definition for PUT-replace tag assignment on media units.
 *
 * PUT /media-units/:id/tags replaces all tag assignments for a unit atomically.
 *
 * Traceability: REQ-2.22
 */
import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { MediaUnitTagsAssignmentSchema } from '../schemas/media-unit-tag-assignment.js';

export const mediaUnitsTags = {
  /** PUT /media-units/:id/tags — replace all tag assignments for a media unit */
  replaceTags: endpoint(
    'PUT',
    '/media-units/:id/tags',
    z.object({ id: z.number() }).merge(MediaUnitTagsAssignmentSchema),
    z.void(),
  ),
};
